import React, { useEffect, useState } from 'react';
import TableFunction from '../../../../../components/table/TableFunction';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from './../../../../../components/DropDown/DropDownMenuItem';
import {
    DetailsIconsOptions,
    IconAreaTable,
    IconClockTable,
    IconScheduleTable,
} from '../../../../../components/buttons/IconButtons';
import CustomChip from '../../../../../components/CustomChip';
import {
    currencyFormat,
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    errorMsg,
    getDateFormat,
    getTimeFormat,
} from '../../../../../Apis/functions';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import {SimpleSearchWithId} from "../../../../../reduxToolkit/Search/SearchApi";
import {SEARCH_MODEL} from "../../../../../components/table/Model/TableModel";
import {TABLES} from "../../../../../Apis/Tables";
import {getItemStatusFines} from '../../Model/Model';
import {colors} from '../../../../../enums/colors';
import {renderCost} from "../../../Dining/Menu/Model/Model";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DetailsTableApp = ({ setDetailsModal, setItemSelected, dateRange, setFinesCount, modified, setModified }) => {
    const tableId = 'tbl_dt_user_details';
    const searchId = 'txt_dt_search_user_details';
    const [data, setData] = useState();
    const { id } = useParams();
    let dispatch = useDispatch();

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes='first_head'>
                {t('infraction_date')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('due_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('geofence')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('amount')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('payment_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!data || data?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = data?.content?.map((item, index) => {
            const statusFineId = getItemStatusFines(item);
            return (
                <>
                    <CustomTd tableId={tableId} classes={'first-column'}>
                        <div className={'d-flex'}>
                            <div className={"d-flex align-items-center mr-2 icon-color-general-950"}>
                                <IconScheduleTable />
                            </div>
                            {getDateFormat(item.fineDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                        <div className={'d-flex'}>
                            <div className={"d-flex align-items-center mr-2 icon-color-general-950"}>
                                <IconClockTable />
                            </div>
                            {getTimeFormat(item?.fineDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <div className={"d-flex align-items-center mr-2 icon-color-general-950"}>
                                <IconScheduleTable />
                            </div>
                            {item?.paymentDate
                                ? getDateFormat(item.paymentDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                                : EMPTY_VALUES.DEFAULT}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <div className={"mr-2"}>
                                <IconAreaTable/>
                            </div>
                            {item?.geofenceName}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {renderCost(item?.paidAmount)}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.paymentType  ?
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={item?.paymentType ? t(item?.paymentType) : EMPTY_VALUES.DEFAULT}
                                variant={'compact'}
                            />
                            : EMPTY_VALUES.DEFAULT
                        }

                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[statusFineId]}
                            fontColor={statusFontColor[statusFineId]}
                            borderColor={statusBorderColor[statusFineId]}
                            legend={t(status[statusFineId])}
                            variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data?.content,
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('details')}
                        icon={<DetailsIconsOptions />}
                        click={() => {
                            setItemSelected(item?.id);
                            setDetailsModal(true);
                        }}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const { start, end } = dateRange.toRegister();
        // Validate both dates before dispatching the request
        if (start && end) {
            const body = SEARCH_MODEL.setObject({
                page: page,
                size: rowsPerPage,
                model: TABLES.FINE_USER,
                userId: id,
                attendanceStartDate:start,
                attendanceEndDate:end
            });

            dispatch(SimpleSearchWithId({ body }),).then(({ payload:{data:{data,success,code}} }) => {
                if (success) {
                    setData(data);
                    setFinesCount(data.totalElements)
                } else errorMsg(code);
            });
        }
    }

    const { t, thead, tbody, openMenu, handleMenuToggle, pagination, rowsPerPage, handleClose } = TableFunction({
        data,
        labelRowsPerPage: 'fines_per_page',
        getTbody,
        getThead,
        fixedPagination: false, // Disable fixed pagination display
        hasContainer: false, // Set up pagination container
        getData,//New
        modified,//New
        setModified,//New
    });
    // Fetch fines only when both start and end dates are defined
    useEffect(() => {
        getData(0);
    }, [dateRange]);

    return {
        pagination,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        data
    };
};

export default DetailsTableApp;
